module.exports = __webpack_public_path__ + "static/media/iphone 11 banner4.840cfb85.jpg";